import { UseQueryResult, UseMutationResult, useQuery, useMutation } from '@tanstack/react-query';
import { FileMetaDataDto } from '@/shared/api/model';
import { 
    useGetMeta, 
    useGetMetaAll, 
    useUpdateFileInfo as useUpdateFileInfoOrval,
    getGetMetaQueryKey,
    getGetMetaAllQueryKey
} from '@/shared/api/client/file-upload';
import { AxiosResponse } from 'axios';

// Hook for getting metadata by category
export const useGetMetaByCategory = (category: string) => {
    const query = useGetMeta({ category });
    
    // Extract data from nested axios response and maintain the original interface
    // @ts-ignore
    const result = {
        ...query,
        data: query.data,
        error: query.error as Error
    } as UseQueryResult<FileMetaDataDto[], Error>;

    const refetch = () => query.refetch();
    
    return [result, refetch] as [UseQueryResult<FileMetaDataDto[], Error>, () => void];
};

// Hook for getting all metadata
export const useGetAllMeta = () => {
    const query = useGetMetaAll();
    
    // Extract data from nested axios response and maintain the original interface
    // @ts-ignore
    const result = {
        ...query,
        data: query.data,
        error: query.error as Error
    } as UseQueryResult<FileMetaDataDto[], Error>;

    const refetch = () => query.refetch();
    
    return [result, refetch] as [UseQueryResult<FileMetaDataDto[], Error>, () => void];
};

// Hook for updating file info
export const useUpdateFileInfo = () => {
    const mutation = useUpdateFileInfoOrval({
        mutation: {
            onSuccess: (data: any) => {
                // You can add any success handling here, like invalidating queries
                console.log('File info updated successfully', data);
            },
            onError: (error: any) => {
                console.error('Error updating file info', error);
            },
        }
    });

    // Adapt Orval mutation to match original interface
    return {
        ...mutation,
        mutateAsync: async (data: FileMetaDataDto) => {
            const response = await mutation.mutateAsync({ data });
            return response;
        },
        mutate: (data: FileMetaDataDto, options: any) => {
            mutation.mutate({ data }, options);
        },
        data: mutation.data
    } as UseMutationResult<FileMetaDataDto, Error, FileMetaDataDto>;
};
